
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { MyBalanceMixin, TeamUserMixin } from '@/mixins';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';
import BalanceDetailsDialog from '@/components/BalanceCard/BalanceDetailsDialog.vue';
import TokensSVG from '@/assets/TokensSVG.vue';
import BaseStyledMenu from '@/components/base/BaseStyledMenu.vue';
import GlassButton from '@/components/base/GlassButton.vue';
import RunnitPlanTokensUsageMenuOrBottomSheet from '@/views/Runnits/RunnitSideNav/RunnitPlanTokensUsageMenuOrBottomSheet.vue';
import {
	CHECKOUT_ADD_FUNDS,
	CHECKOUT_ADD_FUNDS_TEAM,
} from '@run-diffusion/shared';
import { SNACKBAR_STATUS } from '@/constants/constants';
import { getDomainClaimRestrictionMessage } from '@/utils/domainClaimRestriction';

export default Vue.extend({
	name: 'BalanceCard',
	mixins: [
		MyBalanceMixin,
		TeamUserMixin,
	],
	props: {
		styles: { type: [String, Object], default: null },
		selectionEnabled: { type: Boolean, default: false },
		paidTokensOnly: { type: Boolean, default: false },
	},
	data () {
		return {
			detailsDialogData: {
				open: false,
			},
			MENU_ITEM_VALUE: {
				SEE_DETAILS: 'see-details',
				ADD_FUNDS: 'add-funds',
			},
		};
	},
	computed: {
		...mapState([
			'team',
			'userBalanceAccount',
			'teamBalanceAccount',
			'runnitState',
		]),
		...mapGetters([
			'displayLabels',
			'activeDomainClaimRestriction',
		]),
		teamSelected () {
			return this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM;
		},
		openSourceBalanceMenuItems () {
			return [
				{
					id: 0,
					icon: 'mdi-information-outline',
					label: 'View Details',
					description: 'View open-source balance details',
					value: this.MENU_ITEM_VALUE.SEE_DETAILS,
				},
				{
					id: 1,
					icon: 'mdi-cash-plus',
					label: 'Add Funds',
					description: `Pay for more ${this.teamSelected ? this.displayLabels.team : 'personal'} open-source funds`,
					value: this.MENU_ITEM_VALUE.ADD_FUNDS,
				},
			];
		},
		usableTokenBalance () {
			return this.paidTokensOnly
				? this.balanceAccountRunnitTokensData.runnitTokens
				: this.balanceAccountRunnitTokensData.combinedTokens;
		},
		showFreeTokenCallout () {
			return !!(
				this.paidTokensOnly &&
				this.balanceAccountRunnitTokensData.freeRunnitTokens > 0
			);
		},
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		openDetailsDialog () {
			this.detailsDialogData = {
				open: true,
			};
		},
		closeDetailsDialog () {
			this.detailsDialogData = {
				open: false,
			};
		},
		onMenuItemSelect (value: string) {
			switch (value) {
				case this.MENU_ITEM_VALUE.SEE_DETAILS:
					this.openDetailsDialog();
					break;
				case this.MENU_ITEM_VALUE.ADD_FUNDS:
					this.handleAddFunds();
					break;
				default:
					break;
			}
		},
		handleAddFunds () {
			if (this.activeDomainClaimRestriction) {
				this.updateSnackbar({
					status: SNACKBAR_STATUS.ERROR,
					message: getDomainClaimRestrictionMessage(this.activeDomainClaimRestriction, this.displayLabels.team),
					show: true,
				});
				return;
			}
			const checkoutAction: string = this.teamSelected ? CHECKOUT_ADD_FUNDS_TEAM : CHECKOUT_ADD_FUNDS;

			const routeData = this.$router.resolve({
				name: 'GoToPayment',
				query: {
					checkoutAction,
				},
			});
			window.open(routeData.href, '_blank');
		},
	},
	components: {
		GlassButton,
		BaseStyledMenu,
		TokensSVG,
		BalanceDetailsDialog,
		RunnitPlanTokensUsageMenuOrBottomSheet,
	},
});
